const React = require("react");
const T = React.PropTypes;

const UploadHistoryActionCreators = require("../actionCreators/UploadHistoryActionCreators.js");

const HistoricalFile = require("../types/HistoricalFile.js");

const HollowButton = require("./HollowButton.jsx");
const TitledMessage = require("./TitledMessage.jsx");
const HttpResponse = require("./HttpResponse.jsx");
const Spinner = require("./Spinner.jsx");

const HistoryFooter = React.createClass({
    props: {
        style: T.object,
        AncientHistory: T.shape({
            HasLoaded: T.bool.isRequired,
            IsLoading: T.bool.isRequired,
            Data: T.arrayOf(HistoricalFile.Type),
            Error: T.object
        })
    },
    getDefaultProps() {
        return {
            style: {}
        };
    },
    render() {
        if (this.props.AncientHistory.Error) {
            const response = this.props.AncientHistory.Error.response;

            return (<footer style={this.props.style}>
                <TitledMessage Subtitle="Your extended history could not be loaded.">
                    <HttpResponse Response={response} style={{ margin: 30, fontSize: 16 }} />
                    <div>
                        <p>
                            <HollowButton style={{ color: "#777" }} hoverStyle={{ color: "#777" }}
                                          onClick={this.LoadAll}>
                                Click here to try it again.
                            </HollowButton>
                        </p>
                        <p>
                            If you continue to see errors, kindly contact support.
                        </p>
                    </div>
                </TitledMessage>
            </footer>);
        }
        else if (this.props.AncientHistory.IsLoading) {
            return (<footer style={this.props.style}>
                <Spinner Message="Loading ancient history..." WithTimer={true} Large={true } />
            </footer>);
        }
        else if (this.props.AncientHistory.HasLoaded) {
            const style = Object.assign({}, this.props.style, {
                color: "#bbb"
            });

            return (<div style={style}>(That's all of them)</div>);
        }

        return (<footer style={this.props.style}>
            <HollowButton style={{ color: "#777" }} hoverStyle={{ color: "#777" }}
                onClick={this.LoadAll}>
                Click here to view your entire file history.
            </HollowButton>
        </footer>);
    },
    LoadAll() {
        UploadHistoryActionCreators.GetAll();
    }
});

module.exports = HistoryFooter;


// WEBPACK FOOTER //
// ./src/components/HistoryFooter.jsx